export default __webpack_public_path__ + "images/assets/4657e9396553547f26b8049b846375f8.svg";